// Entry point for main js
require('./js/main')

// Entry point for sass
require('./sass/main.scss')



//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = 380
// module chunks = 1